// @flow

import type { SetHelmetAction, Helmet as HelmetState } from '../../actions/client';

const initialState = {
  title: '',
  description: '',
  keywords: '',
  ogTitle: '',
  ogDescription: '',
  ogImage: '',
  ogType: '',
  googleSchema: {},
  nextCursor: '',
  prevCursor: '',
  currentCursor: '',
  canonicalRoute: '',
};

export default function helmet(state: HelmetState = initialState, action: SetHelmetAction) {
  if (action.type === 'SET_HELMET') {
    return action.helmet || initialState;
  }

  return state;
}
